import { render, staticRenderFns } from "./IconTypeformLegal.vue?vue&type=template&id=0cc6dfb2&"
import script from "./IconTypeformLegal.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformLegal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports